import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ProductsModalComponent } from './products-modal.component';


@Component({
  selector: 'app-product-field',
  templateUrl: './product-field.component.html',
  styles: [],

  // This part is reponsible for the integration of the input inside the angular forms
  // It allows angular formControl element to communicate with our custom input
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: ProductFieldComponent,
    multi: true
  }]
})
export class ProductFieldComponent implements ControlValueAccessor {
  @Input() public disabled: boolean;
  @Input() public filters: any;
  @Input() public disabledColumns: any;
  @Input() public disabledButtons: any;
  @Input() public priceBookEntityCode: string;
  @Input() public disabledWoogleSearch = true;
  @Output() public productConfigChosen = new EventEmitter<any>();

  public detail: any;
  public onChangeCb: any;

  constructor(private ngbModal: NgbModal) { }

  public choose(): void {
    if (this.disabled) {
      return;
    }

    const modal = this.ngbModal.open(ProductsModalComponent, {size: 'lg'});
    modal.componentInstance.disabledColumns = this.disabledColumns;
    modal.componentInstance.disabledButtons = this.disabledButtons;
    modal.componentInstance.priceBookEntityCode = this.priceBookEntityCode;
    modal.componentInstance.filters = this.filters;
    modal.componentInstance.disabledWoogleSearch = this.disabledWoogleSearch;

    modal.result.then((res) => {
      if (!this.disabledWoogleSearch && res?.code?.startsWith('PC-') && res?.product?.code?.startsWith('P-')) {
        // Result from catalogue search: res is a product-config, extract the product
        this.detail = res.product;
        this.onChangeCb(this.detail);
        this.productConfigChosen.emit(res);
      } else {
        this.detail = res;
        this.onChangeCb(this.detail);
      }
    }, () => {});
  }

  public reset(): void {
    this.detail = null;
    this.onChangeCb(this.detail);
  }


  // These 3 functions are part of the NG_VALUE_ACCESSOR
  // they must be implemented for Angular to access our input
  public writeValue(value): void {
    // This function is called by Angular when the formControl element has its value updated
    this.detail = value;
  }

  public registerOnChange(fn) {
    // This function is used by Angular to listen to the update of our custom control
    this.onChangeCb = fn;
  }

  public registerOnTouched() {
    // This function is used by Angular to know if our element has been touched by the user
  }
}
